export default __webpack_public_path__ + "static/media/spin-bg-17.8d5fbd36.png";